import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
import connect from 'react-redux/es/connect/connect';
// import { getAllAdminUsersData } from 'Actions/adminActions';
import { getAllAdminUsersDataByType } from 'Actions/adminActions';
import { deactivateUserById } from 'Actions/adminActions';
import { approveUserById } from 'Actions/adminActions';
import { disApproveUserById } from 'Actions/adminActions';
import TableUser from './components/TableUser';
import styled from 'styled-components';
import UserProfile from './components/UserProfile';
import CompanyProfile from './components/CompanyProfile';
import InviteUsers from './components/InviteUsers';
import DeactivateDialog from './components/DeactivateDialog';
import ApproveDialog from './components/ApproveDialog';
import { getSingleAdminUserData } from 'Actions/adminActions';
import axios from 'Axios';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import Zoom from '@material-ui/core/Zoom';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Invite from '@material-ui/icons/PersonAdd';

const StateWrapper = styled.div`
  font-weight: bold;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  background-color: ${props => {
    switch (props.status) {
      case 'Active':
        return '#4CAF50';
      case 'Pending':
        return '#C69A00';
      case 'Deactivated':
        return '#F44336';
      case 'Pending_approval':
        return '#4390bc';
      case 'Deactivated_permanently':
        return '#7E7E7E';
      default:
        return '#000';
    }
  }};
`;

const TableCellCustom = styled(TableCell)`
  padding: 0 10px !important;
`;

const TableCellCustomClicable = styled(TableCell)`
  cursor: pointer;
  padding: 0 10px !important;
`;

const TableCellCustomHead = styled(TableCell)`
  cursor: pointer;
  padding: 0 10px !important;
  color: white !important;
`;
const TableRowCustom = styled(TableRow)`
  :hover {
    background-color: rgba(0, 0, 0, 0.07) !important;
    outline: rgba(55, 70, 79, 0.9) solid 1px;
    outline: rgba(55, 70, 79, 0.9) solid 1px;
  }
`;

const TooltipCustom = styled(Tooltip)`
  font-size: 13px !important;
`;
const TooltipForStatus = styled(Tooltip)`
  font-size: 16px !important;
`;
const Loader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50vh;
`;
const LoaderIcon = styled(CircularProgress)`
  max-width: 50%;
  width: 60px !important;
  height: 60px !important;
`;
const ActionWrapper = styled.div`
  background-color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 1024px) {
    flex-direction: column;
  }
`;
const TextFieldCustom = styled(TextField)`
  margin: 15px !important;
  min-width: 15% !important;
  width: 130px;
`;
const ButtonCustom = styled(Button)`
  margin: 15px !important;
`;
const InviteIcon = styled(Invite)`
  margin-right: 15px;
`;

var isNumber = function isNumber(value) {
  return typeof value === 'number' && isFinite(value);
};

function desc(a, b, orderBy) {
  var isFirstEmpty = a[orderBy] === '-' ? true : false;
  var isSecondEmpty = b[orderBy] === '-' ? true : false;

  if (isFirstEmpty && isSecondEmpty) {
    return 0;
  } else if (isFirstEmpty) {
    return 1;
  } else if (isSecondEmpty) {
    return -1;
  }

  if (isNumber(a[orderBy]) && isNumber(b[orderBy])) {
    return a[orderBy] - b[orderBy];
  }

  var firstValue = a[orderBy];
  var secondValue = b[orderBy];

  if (Array.isArray(firstValue)) {
    firstValue = firstValue.join(', ');
  }

  if (Array.isArray(secondValue)) {
    secondValue = secondValue.join(', ');
  }

  return firstValue.localeCompare(secondValue);
}

function asc(a, b, orderBy) {
  var isFirstEmpty = a[orderBy] === '-' ? true : false;
  var isSecondEmpty = b[orderBy] === '-' ? true : false;

  if (isFirstEmpty && isSecondEmpty) {
    return 0;
  } else if (isFirstEmpty) {
    return 1;
  } else if (isSecondEmpty) {
    return -1;
  }

  if (isNumber(a[orderBy]) && isNumber(b[orderBy])) {
    return -(a[orderBy] - b[orderBy]);
  }

  var firstValue = a[orderBy];
  var secondValue = b[orderBy];

  if (Array.isArray(firstValue)) {
    firstValue = firstValue.join(', ');
  }

  if (Array.isArray(secondValue)) {
    secondValue = secondValue.join(', ');
  }

  return -firstValue.localeCompare(secondValue);
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
  return order === 'desc'
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => asc(a, b, orderBy);
}

const rows1 = [
  { id: 'state', numeric: false, disablePadding: true, label: 'Status' },
  { id: 'firstName', numeric: false, disablePadding: true, label: 'User' },
  {
    id: 'companyName',
    numeric: false,
    disablePadding: true,
    label: 'Company',
  },
  {
    id: 'joinedLB',
    numeric: false,
    disablePadding: true,
    label: 'Joined LB (UTC)',
  },
  {
    id: 'lastLoginDate',
    numeric: false,
    disablePadding: true,
    label: 'Last login (UTC)',
  },
  {
    id: 'averageRating',
    numeric: false,
    disablePadding: true,
    label: 'Average Rating',
  },
  { id: 'penalty', numeric: false, disablePadding: true, label: 'Penalty' },
  {
    id: 'numberOfLuminaires',
    numeric: false,
    disablePadding: true,
    label: 'Luminaires',
  },
  {
    id: 'numberOfMatches',
    numeric: false,
    disablePadding: true,
    label: 'Matches',
  },
  {
    id: 'numberOfSelections',
    numeric: false,
    disablePadding: true,
    label: 'Selections',
  },
  {
    id: 'numberOfTickets',
    numeric: false,
    disablePadding: true,
    label: 'Searches',
  },
  {
    id: 'numberOfProjects',
    numeric: false,
    disablePadding: true,
    label: 'Projects',
  },
  { id: 'regions', numeric: false, disablePadding: true, label: 'Regions' },
];
const customColumnStyleRegion = { minWidth: '180px' };
const customColumnStyleUser = { minWidth: '230px' };
const customColumnStyleJoined = { minWidth: '70px' };
const customColumnStyleStatus = { width: '60px' };

class EnhancedTableHead extends React.Component {
  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  fixWidth = column => {
    switch (column) {
      case 'firstName':
        return customColumnStyleUser;
      case 'region':
        return customColumnStyleRegion;
      case 'joinedLB':
        return customColumnStyleJoined;
      case 'state':
        return customColumnStyleStatus;
      default:
        return null;
    }
  };

  render() {
    const { order, orderBy, arupUsers } = this.props;
    let rows = rows1;
    if (arupUsers) {
      rows = rows.filter(
        row =>
          // row.id !== 'companyName' && // COMPANY FIELD
          row.id !== 'averageRating' &&
          row.id !== 'penalty' &&
          row.id !== 'numberOfLuminaires'
        // row.id !== 'numberOfMatches' &&
        // row.id !== 'numberOfSelections'
      );
    }
    if (!arupUsers) {
      rows = rows.filter(
        row => row.id !== 'numberOfTickets' && row.id !== 'numberOfProjects'
      );
    }
    return (
      <TableHead>
        <TableRow style={{ background: 'rgba(55, 70, 79, 0.9)' }}>
          {rows.map(
            row => (
              <TableCellCustomHead
                key={row.id}
                align={row.numeric ? 'right' : 'left'}
                // padding={row.disablePadding ? 'dense' : 'default'}
                sortDirection={orderBy === row.id ? order : false}
                style={this.fixWidth(row.id)}
              >
                <Tooltip
                  title="Sort"
                  placement={row.numeric ? 'bottom-end' : 'bottom-start'}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === row.id}
                    direction={order}
                    onClick={this.createSortHandler(row.id)}
                  >
                    {row.label}
                  </TableSortLabel>
                </Tooltip>
              </TableCellCustomHead>
            ),
            this
          )}
        </TableRow>
      </TableHead>
    );
  }
}

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: '45px',
    padding: '',
  },
  table: {
    minWidth: 1020,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
});

class CompanyUsers extends React.Component {
  state = {
    order: 'desc',
    orderBy: 'firstName',
    selected: [],
    page: 0,
    rowsPerPage: 10,
    isUserDialogOpen: false,
    isCompanyDialogOpen: false,
    currentUserId: null,
    currentCompanyId: null,
    deactivateDialog: false,
    approveDialog: false,
    disApproveDialog: false,
    deleteDialog: false,
    deactivateUserId: null,
    // status: '',
    userStatus: '',
    userEmail: '',
    registrationLink: '',
    filterThisUser: null,
    resendDialog: false,
    resendMessage: '',
    open: false,
    perma: false,
    loadedData: false,
    openInvateDialog: false,
    filterBy: 'active',
    showUsers: 'all',
  };

  handleChangeFilter = event => {
    this.props.getAllAdminUsersDataByType(
      this.props.arupUsers,
      event.target.value,
      this.state.showUsers !== 'all' ? { show: this.state.showUsers } : null
    );
    this.setState({ [event.target.name]: event.target.value });
  };

  handleChangeUsers = event => {
    this.props.getAllAdminUsersDataByType(
      this.props.arupUsers,
      this.state.filterBy,
      { show: event.target.value }
    );
    this.setState({ [event.target.name]: event.target.value });
  };

  handleCloseSnack = () => {
    this.setState({ open: false, resendMessage: '' });
  };

  goToPendingUsers = () => {
    this.setState({
      filterBy: 'pending',
    });
  };

  handleOpenCloseInvateDialog = () => {
    this.setState({ openInvateDialog: !this.state.openInvateDialog });
  };

  openDeactivateDialog = (companyId, userId, status, perma) => event => {
    this.setState({
      deactivateDialog: true,
      deactivateUserId: userId,
      deactivateUserCompanyId: companyId,
      perma: perma,
    });
  };

  openApproveDialog = (companyId, userId) => event => {
    this.setState({
      approveDialog: true,
      deactivateUserId: userId,
      deactivateUserCompanyId: companyId,
      // status: status,
    });
  };

  openDisapproveDialog = (companyId, userId) => event => {
    this.setState({
      disApproveDialog: true,
      deactivateUserId: userId,
      deactivateUserCompanyId: companyId,
      // status: status,
    });
  };

  openDeleteDialog = email => event => {
    this.setState({
      userEmail: email,
      deleteDialog: true,
    });
  };

  openResendDialog = email => event => {
    this.setState({
      resendDialog: true,
    });
  };

  closeDeactivateDialog = () => {
    this.setState({
      deactivateDialog: false,
      deactivateUserId: null,
      deactivateUserCompanyId: null,
    });
  };

  closeApproveDialog = () => {
    this.setState({
      approveDialog: false,
      deactivateUserId: null,
      deactivateUserCompanyId: null,
    });
  };
  closeDisapproveDialog = () => {
    this.setState({
      disApproveDialog: false,
      deactivateUserId: null,
      deactivateUserCompanyId: null,
    });
  };

  closeDeleteDialog = () => {
    this.setState({
      deleteDialog: false,
    });
  };

  closeResendDialog = () => {
    this.setState({
      resendDialog: false,
    });
  };

  componentDidMount() {
    // this.props.getAllAdminUsersData(this.props.arupUsers);
    this.props.getAllAdminUsersDataByType(
      this.props.arupUsers,
      this.state.filterBy
    );
  }

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({ order, orderBy });
  };

  handleUserClick = user => {
    this.setState({
      isUserDialogOpen: true,
      currentUserId: user.userId,
      currentCompanyId: user.companyId,
      userStatus: user.state,
      userEmail: user.email,
      registrationLink: user.registrationLink,
    });
  };
  handleCompanyClick = currentCompanyId => {
    this.setState({
      isCompanyDialogOpen: true,
      currentCompanyId,
    });
  };
  handleCloseUserDialog = () => {
    this.setState({ isUserDialogOpen: false });
  };
  handleCloseCompanyDialog = () => {
    this.setState({ isCompanyDialogOpen: false });
  };
  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
  };

  deactivateUser = (companyId, userId, perma) => event => {
    this.props.deactivateUserById(companyId, userId, perma);
    this.closeDeactivateDialog();
  };
  approveUser = (companyId, userId) => event => {
    this.props.approveUserById(companyId, userId);
    this.closeApproveDialog();
  };
  disApproveUser = (companyId, userId) => event => {
    this.props.disApproveUserById(companyId, userId);
    this.closeDisapproveDialog();
  };

  renderRegions = regions => {
    if (regions.length < 2) return regions[0];
    if (regions.length == 2) return `${regions[0]}, ${regions[1]}`;

    return (
      <TooltipCustom title={this.splitRegions(regions)}>
        <Typography>{`${regions[0]}, ${regions[1]}...`}</Typography>
      </TooltipCustom>
    );
  };

  splitRegions = regions => {
    if (regions !== undefined && regions !== '-') {
      let stringOfRegions;
      stringOfRegions = regions.join(', ');
      if (stringOfRegions.indexOf('_') !== -1) {
        stringOfRegions = stringOfRegions.replace(/_/g, ' ');
      }
      return stringOfRegions;
    }
    return regions;
  };

  deleteInvitation = email => event => {
    axios
      .post(
        'admin/users/delete',
        { email: email },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
      .then(res => {
        if (res) {
          this.props.getAllAdminUsersDataByType(
            this.props.arupUsers,
            this.state.filterBy
          );
        }
        this.setState({ isUserDialogOpen: false });
      })
      .catch(err => {
        this.setState(state => ({
          error: err,
          // viewState: ProfileMachine.transition(state.viewState, 'ERROR').value,
        }));
      });
    this.closeDeleteDialog();
  };

  resendInvitation = email => event => {
    axios
      .post(
        'admin/invite/resend',
        { email: email },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
      .then(res => {
        if (res) {
          // this.props.getAllAdminUsersData(this.props.arupUsers);
          this.props.getAllAdminUsersDataByType(
            this.props.arupUsers,
            this.state.filterBy
          );
        }
        this.setState(
          {
            resendMessage: 'Invitation sent',
            isUserDialogOpen: false,
          },
          () => {
            this.setState({ open: true });
          }
        );
      })
      .catch(err => {
        this.setState(state => ({
          error: err,
          // viewState: ProfileMachine.transition(state.viewState, 'ERROR').value,
        }));
      });
    this.closeResendDialog();
  };

  getStripedStyle(index) {
    return { background: index % 2 ? '#fafafa' : 'rgba(55, 70, 79, 0.08)' };
  }
  showLoader(loading) {
    if (loading.action.realAction === 'GET_All_ADMIN_USERS_DATA_START') {
      return true;
    } else if (loading.action.realAction === 'GET_All_ADMIN_USERS_DATA_START') {
      return false;
    }
    return false;
  }

  render() {
    const { classes, users, arupUsers, loading } = this.props;
    const loader = this.showLoader(loading);
    const { order, orderBy, selected, rowsPerPage, page } = this.state;
    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, users.length - page * rowsPerPage);

    // this is used for action on user activate/deactivate to update in realtime
    let user = users.filter(user => user.userId === this.state.currentUserId);
    const status = user.length > 0 && user[0].state;
    //...
    return (
      <React.Fragment>
        <ActionWrapper>
          <div>
            <TextFieldCustom
              id="filterBy"
              value={this.state.filterBy}
              onChange={this.handleChangeFilter}
              select
              label="Filter by: "
              name="filterBy"
              variant="outlined"
            >
              <MenuItem key={'all'} value={'all'}>
                All
              </MenuItem>
              <MenuItem key={'active'} value={'active'}>
                Active
              </MenuItem>
              <MenuItem key={'pending'} value={'pending'}>
                Pending
              </MenuItem>
              <MenuItem key={'inactive'} value={'inactive'}>
                Inactive
              </MenuItem>
            </TextFieldCustom>

            {arupUsers && (
              <TextFieldCustom
                id="showUsers"
                value={this.state.showUsers}
                onChange={this.handleChangeUsers}
                select
                label="Show: "
                name="showUsers"
                variant="outlined"
              >
                <MenuItem key={'all'} value={'all'}>
                  All
                </MenuItem>
                <MenuItem key={'arup'} value={'arup'}>
                  Arup users
                </MenuItem>
                <MenuItem key={'nonarup'} value={'nonarup'}>
                  Non-arup users
                </MenuItem>
              </TextFieldCustom>
            )} 
          </div>

          <TablePagination
            rowsPerPageOptions={[10, 25, 50, 100]}
            component="div"
            count={users.length}
            rowsPerPage={rowsPerPage}
            page={page}
            backIconButtonProps={{
              'aria-label': 'Previous Page',
            }}
            nextIconButtonProps={{
              'aria-label': 'Next Page',
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />

          <ButtonCustom
            variant="outlined"
            onClick={this.handleOpenCloseInvateDialog}
          >
            <InviteIcon />
            Invite
          </ButtonCustom>
        </ActionWrapper>

        {!loader ? (
          <Paper className={classes.root}>
            <div className={classes.tableWrapper}>
              <Table className={classes.table} aria-labelledby="tableTitle">
                <EnhancedTableHead
                  numSelected={selected.length}
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={this.handleRequestSort}
                  rowCount={users.length}
                  arupUsers={arupUsers}
                />
                <TableBody>
                  {stableSort(users, getSorting(order, orderBy))
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((n, index) => {
                      return (
                        <TableRowCustom
                          style={this.getStripedStyle(index)}
                          hover
                          role="button"
                          tabIndex={-1}
                          key={index}
                        >
                          <TableCellCustomClicable
                            onClick={() => this.handleUserClick(n)}
                            align="left"
                          >
                            <TooltipForStatus
                              title={
                                <span style={{ fontSize: '20px' }}>
                                  {n.state === 'Pending_approval'
                                    ? 'Pending approval'
                                    : n.state === 'Pending'
                                    ? 'Pending registration'
                                    : n.state === 'Deactivated_permanently'
                                    ? 'Deactivated permanently'
                                    : n.state}
                                </span>
                              }
                              placement={'right'}
                              enterDelay={100}
                              TransitionComponent={Zoom}
                            >
                              <StateWrapper status={n.state} />
                            </TooltipForStatus>
                          </TableCellCustomClicable>
                          <TableCellCustomClicable
                            onClick={() => this.handleUserClick(n)}
                            component="th"
                            scope="row"
                            padding="none"
                            style={{ width: '50px' }}
                          >
                            <TableUser
                              name={`${n.firstName} ${
                                n.lastName !== '-' ? n.lastName : ''
                              }`}
                              img={n.profileImageId}
                            />
                          </TableCellCustomClicable>

                          {arupUsers ? (
                            // <TableCellCustomClicable
                            //   align="left"
                            //   onClick={() =>
                            //     this.handleCompanyClick(n.companyId)
                            //   }
                            // >
                            //   {n.companyName}
                            // </TableCellCustomClicable>
                            <TableCellCustom align="left">
                              {n.companyName}
                            </TableCellCustom>
                          ) : (
                            <TableCellCustomClicable
                              align="left"
                              onClick={() =>
                                this.handleCompanyClick(n.companyId)
                              }
                            >
                              {n.companyName}
                            </TableCellCustomClicable>
                          )}

                          <TableCellCustom align="left">
                            {n.joinedLB}
                          </TableCellCustom>
                          <TableCellCustom align="left">
                            {n.lastLoginDate}
                          </TableCellCustom>
                          {arupUsers ? (
                            <React.Fragment>
                              <TableCellCustom align="left">
                                {n.numberOfMatches ? n.numberOfMatches : '-'}
                              </TableCellCustom>
                              <TableCellCustom align="left">
                                {n.numberOfSelections
                                  ? n.numberOfSelections
                                  : '-'}
                              </TableCellCustom>
                              <TableCellCustom align="left">
                                {n.numberOfTickets ? n.numberOfTickets : '-'}
                              </TableCellCustom>
                              <TableCellCustom align="left">
                                {n.numberOfProjects ? n.numberOfProjects : '-'}
                              </TableCellCustom>
                              <TableCellCustom align="left">
                                {this.renderRegions(n.regions)}
                              </TableCellCustom>
                            </React.Fragment>
                          ) : (
                            <React.Fragment>
                              <TableCellCustom align="left">
                                {n.averageRating ? n.averageRating : '-'}
                              </TableCellCustom>
                              <TableCellCustom align="left">
                                {n.penalty}
                              </TableCellCustom>
                              <TableCellCustom align="left">
                                {n.numberOfLuminaires
                                  ? n.numberOfLuminaires
                                  : '-'}
                              </TableCellCustom>
                              <TableCellCustom align="left">
                                {n.numberOfMatches ? n.numberOfMatches : '-'}
                              </TableCellCustom>
                              <TableCellCustom align="left">
                                {n.numberOfSelections
                                  ? n.numberOfSelections
                                  : '-'}
                              </TableCellCustom>
                              <TableCellCustom align="left">
                                {this.renderRegions(n.regions)}
                              </TableCellCustom>
                            </React.Fragment>
                          )}
                        </TableRowCustom>
                      );
                    })}
                  {emptyRows > 0 && (
                    <TableRow
                      key={`empty_row`}
                      style={{ height: 49 * emptyRows }}
                    >
                      <TableCellCustom colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </div>

            <Dialog
              onClose={this.handleCloseUserDialog}
              aria-labelledby="customized-dialog-title"
              open={this.state.isUserDialogOpen}
            >
              <UserProfile
                onClose={this.handleCloseUserDialog}
                userId={this.state.currentUserId}
                companyId={this.state.currentCompanyId}
                arupUsers={arupUsers}
                email={this.state.userEmail}
                status={status}
                trigerOpenDeactivateDialog={this.openDeactivateDialog}
                trigerOpenApproveDialog={this.openApproveDialog}
                trigerOpenDisapproveDialog={this.openDisapproveDialog}
                trigerResendDialog={this.openResendDialog}
                trigerOpenDeleteDialog={this.openDeleteDialog}
                state={this.state}
                registrationLink={this.state.registrationLink}
              />
            </Dialog>
            <Dialog
              onClose={this.handleCloseCompanyDialog}
              aria-labelledby="customized-dialog-title"
              open={this.state.isCompanyDialogOpen}
            >
              <CompanyProfile
                onClose={this.handleCloseCompanyDialog}
                companyId={this.state.currentCompanyId}
              />
            </Dialog>
          </Paper>
        ) : (
          <Loader>
            <LoaderIcon />
          </Loader>
        )}

        <DeactivateDialog
          element={'account'}
          doAction={this.deactivateUser(
            this.state.deactivateUserCompanyId,
            this.state.deactivateUserId,
            this.state.perma
          )}
          handleClose={this.closeDeactivateDialog}
          isOpen={this.state.deactivateDialog}
          status={status}
          isDeactivate={true}
          isPerma={this.state.perma}
        />
        <ApproveDialog
          element={'account'}
          doDelete={this.approveUser(
            this.state.deactivateUserCompanyId,
            this.state.deactivateUserId
          )}
          handleClose={this.closeApproveDialog}
          isOpen={this.state.approveDialog}
          status={status}
          isDeactivate={false}
        />
        <ApproveDialog
          element={'account'}
          doDelete={this.disApproveUser(
            this.state.deactivateUserCompanyId,
            this.state.deactivateUserId
          )}
          handleClose={this.closeDisapproveDialog}
          isOpen={this.state.disApproveDialog}
          status={status}
          isDeactivate={true}
        />
        <DeactivateDialog
          element={'Invitation'}
          // doDelete={this.deactivateUser(
          //   this.state.deactivateUserCompanyId,
          //   this.state.deactivateUserId
          // )}
          doAction={this.deleteInvitation(this.state.userEmail)}
          handleClose={this.closeDeleteDialog}
          isOpen={this.state.deleteDialog}
          isDelete={true}
        />
        <DeactivateDialog
          element={'Resend'}
          // doDelete={this.deactivateUser(
          //   this.state.deactivateUserCompanyId,
          //   this.state.deactivateUserId
          // )}
          doAction={this.resendInvitation(this.state.userEmail)}
          handleClose={this.closeResendDialog}
          isOpen={this.state.resendDialog}
          isResend={true}
        />
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          key={`${'top'},${'center'}`}
          open={this.state.open}
          onClose={this.handleCloseSnack}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={<span id="message-id">{this.state.resendMessage}</span>}
          action={
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={this.handleCloseSnack}
            >
              <CloseIcon />
            </IconButton>
          }
        />
        <InviteUsers
          open={this.state.openInvateDialog}
          closeMessageDialog={this.handleOpenCloseInvateDialog}
          arupUsers={arupUsers}
          filterBy={this.state.filterBy}
          goToPendingUsers={this.goToPendingUsers}
        />
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getAllAdminUsersDataByType: (arupUsers, filterBy, params) => {
    dispatch(getAllAdminUsersDataByType(arupUsers, filterBy, params));
  },
  // getAllAdminUsersData: arupUsers => {
  //   dispatch(getAllAdminUsersData(arupUsers));
  // },
  deactivateUserById: (companyId, userId, perma) => {
    dispatch(deactivateUserById(companyId, userId, perma));
  },
  approveUserById: (companyId, userId) => {
    dispatch(approveUserById(companyId, userId));
  },
  disApproveUserById: (companyId, userId) => {
    dispatch(disApproveUserById(companyId, userId));
  },
});
const mapStateToProps = store => {
  return {
    users: store.adminData.users,
    loading: store.loading,
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(CompanyUsers));
